
<div class="row roles">
  <div class="columns">
    <gw-admin-header [header]="'ADMIN_SETTINGS.ROLES.HEADER' | translate" [addButtonLabel]="'ADMIN_SETTINGS.ROLES.ACTION.ADD_ROLE' | translate" [transparent]="true" [smallMarginTop]="true" (addButtonClick)="onAddRole()"></gw-admin-header>
    <div class="users__content">
      <gw-roles-list [roles]="roles" [users]="users" (editRole)="onEditRole($event)" (removeRole)="onRemoveRole($event)" (openRole)="onOpenRole($event)" (addUserToRole)="onAddUserToRole($event)" (removeUserFromRole)="onRemoveUserFromRole($event)"></gw-roles-list>
    </div>
  </div>
</div>